import PipelineStateIcon, {
  colorForJob,
} from "app/components/shared/PipelineStateIcon/PipelineStateIcon";
import { Job } from "app/stores/BuildShowStore";
import classNames from "classnames";
import { SortFn } from ".";
import { JobStates } from "app/components/build/Header/pipeline/types/jobStates";
import { CommandJob } from "app/components/build/Header/pipeline/types/CommandJob";
import { TriggerJob } from "app/components/build/Header/pipeline/types/TriggerJob";

export function State({ job }: { job: Job }) {
  return (
    <PipelineStateIcon
      job={job}
      className={classNames("w-4 h-4 block", colorForJob(job))}
      style={{ width: undefined, height: undefined }}
    />
  );
}

// Essentially the same as JobStates except with the finished state resolved to either: passed, hard_failed, and soft_failed
// to allow for sorting by state.
type ResolvedJobState =
  | Exclude<JobStates, "finished">
  | "hard_failed"
  | "soft_failed"
  | "passed";

function resolveState(job: CommandJob | TriggerJob): ResolvedJobState {
  if (job.state === "finished") {
    if (!job.passed) {
      return "hard_failed";
    }
    if (job.softFailed) {
      return "soft_failed";
    }
    return "passed";
  }
  return job.state;
}

const prioritisedStates: ResolvedJobState[] = [
  // Failed
  "hard_failed",
  "canceled",
  "canceling",
  "timed_out",
  "expired",

  // Running
  "running",

  // Scheduled
  "accepted",
  "assigned",
  "scheduled",
  "limited",
  "limiting",

  // Waiting
  "waiting",
  "blocked",

  // Soft failed
  "soft_failed",

  // Passed
  "passed",
  "unblocked",

  // Initial states (pending, skipped, broken)
  "pending",
  "skipped",
  "broken",
];

// eslint-disable-next-line id-length
export const sortByState: SortFn = (direction) => (a, b) => {
  const aState = resolveState(a as CommandJob | TriggerJob);
  const bState = resolveState(b as CommandJob | TriggerJob);
  const aIndex = prioritisedStates.indexOf(aState);
  const bIndex = prioritisedStates.indexOf(bState);

  if (aIndex === bIndex) {
    return 0;
  }

  if (direction === "asc") {
    return aIndex - bIndex;
  }

  return bIndex - aIndex;
};
